<template>
  <div class="flex flex-col w-full h-screen justify-center items-center text-center px-5">
    <div class="text-[1.5rem] leading-[2.25rem] font-black text-[#0B0C0F] tracking-[-0.03em]">
      Reset Email
    </div>
    <div class="text-[#637083] mt-[8px]">Yay! Your email has been reset! 🎉</div>

    <BottomButton text="Back to Login" @click="backToLogin" class="my-[32px]" />
  </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';

export default {
  components: {
    BottomButton,
  },
  methods: {
    backToLogin() {
      this.$router.push('/login');
    },
  },
};
</script>
